<template lang="pug">
  #change-password
    b-card(header-tag="header")
      b-button.ml-3.mb-3(v-b-modal.order_confirm, variant="outline-success", :disabled="isLoading") 送信する
      b-form-text.ml-3.mb-2.align-left.text-left.error-message-color(v-for="(error_msg, key) of error_msg_list", :key="key") {{error_msg}}
      b-modal#order_confirm(centered, size="ml", title="ご確認", @ok="changePage", ok-title="はい", cancel-title="いいえ")
        span 入力内容を送信します。<br>本当によろしいですか？
      change-password-form(:password="password", :re_password="re_password")
      b-button.ml-3.mt-3(v-b-modal.order_confirm, variant="outline-success", :disabled="isLoading") 送信する
</template>

<script>
import ChangePasswordForm from "@/components/supportSite/ChangePasswordForm";
import Api from "@/repositories/api";

const S207PasswordChangesRepository = Api.get('s207PasswordChanges');

export default {
  name: "ChangePassword",
  components: {
    ChangePasswordForm
  },
  data() {
    return {
      // パスワード
      password: {
        value: "",
        placeholder: "6文字以上・半角英数字記号",
        error_msg_list: []
      },

      // パスワード確認
      re_password: {
        value: "",
        placeholder: "確認のためにもう一度入力してください",
        error_msg_list: []
      },

      // 画面上部のエラーメッセージ
      error_msg_list: [],
    }
  },
  methods: {
    changePage() {
      // 入力オブジェクト取得
      const vueData = this;

      // 入力データセット
      let arInputData = {
        password: vueData.password.value,
        re_password: vueData.re_password.value
      };

      // 次へボタンをロックする
      this.isLoading = true;

      // 更新処理呼び出し
      S207PasswordChangesRepository.post(arInputData)
      // 更新処理成功
      .then(() => {
        this.$router.push({
          name: 'ShowCustomerInfo',
        })
      })
      // 入力値エラー処理
      .catch((error) => {
        // 次へボタンをロックを解除する
        this.isLoading = false;

        // 共通のエラー処理
        this.apiError(error, '画面表示処理', "Support")

        // 既存のエラーメッセージをリセット
        vueData.password.error_msg_list    = []; // パスワード
        vueData.re_password.error_msg_list = []; // パスワード(確認用)
        vueData.error_msg_list             = []; // 画面上部のエラーメッセージ

        // httpステータスコードが403の場合（権限エラー）
        if (error.response.status === 403) {
          // 画面上部にエラーメッセージを表示する
          vueData.error_msg_list.push(this.forbidden_message);

          // 画面一番上へスクロールする
          this.pageTopScroll();
        }
        else {
          // エラーリストの読み込み
          const arErrorList = error.response.data.error_list;

          // 各エラーメッセージを画面に埋め込む
          for (let i = arErrorList.length - 1; i >= 0; i--) {
            // エラーメッセージを表示する入力欄が指定されていない
            if (typeof arErrorList[i].target === 'undefined') {
              // 画面上部にエラーメッセージを表示
              vueData.error_msg_list.push(arErrorList[i].error_msg)
            }

            switch (arErrorList[i].target) {
              case "password":
                vueData.password.error_msg_list.push(arErrorList[i].error_msg)
                break
              case "re_password":
                vueData.re_password.error_msg_list.push(arErrorList[i].error_msg)
                break
            }
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>